import type { ChatSubagentStatus } from "../ui-types.ts";
import { isSubagentRunActive } from "./subagent-run-status.ts";

export type SessionTabActivity = {
  unread: number;
  running: boolean;
};

export type SessionTabActivityMap = Record<string, SessionTabActivity>;

export function emptySessionTabActivity(): SessionTabActivity {
  return { unread: 0, running: false };
}

export function bumpSessionTabUnread(
  map: SessionTabActivityMap,
  sessionKey: string,
): SessionTabActivityMap {
  const key = sessionKey.trim();
  if (!key) {
    return map;
  }
  const prev = map[key] ?? emptySessionTabActivity();
  return { ...map, [key]: { ...prev, unread: prev.unread + 1 } };
}

export function clearSessionTabUnread(
  map: SessionTabActivityMap,
  sessionKey: string,
): SessionTabActivityMap {
  const key = sessionKey.trim();
  if (!key || !map[key]?.unread) {
    return map;
  }
  return { ...map, [key]: { ...map[key], unread: 0 } };
}

export function setSessionTabRunning(
  map: SessionTabActivityMap,
  sessionKey: string,
  running: boolean,
): SessionTabActivityMap {
  const key = sessionKey.trim();
  if (!key) {
    return map;
  }
  const prev = map[key] ?? emptySessionTabActivity();
  if (prev.running === running) {
    return map;
  }
  return { ...map, [key]: { ...prev, running } };
}

export function syncSubagentTabRunning(
  map: SessionTabActivityMap,
  cards: Array<{ childSessionKey?: string; status?: ChatSubagentStatus }>,
): SessionTabActivityMap {
  let next = map;
  const activeKeys = new Set<string>();
  for (const card of cards) {
    const key = card.childSessionKey?.trim();
    if (!key) {
      continue;
    }
    const running = card.status != null && isSubagentRunActive(card.status);
    if (running) {
      activeKeys.add(key);
    }
    next = setSessionTabRunning(next, key, running);
  }
  for (const key of Object.keys(next)) {
    if (next[key]?.running && !activeKeys.has(key) && key.includes(":subagent:")) {
      next = setSessionTabRunning(next, key, false);
    }
  }
  return next;
}
